import { createReducer } from 'redux-starter-kit';
import { queriesActions } from '../actions';
import getStdDbModelReduxMapping from './std-db-model-reducers';

export const queriesInitialState = {};

const queriesReducer = createReducer(
  queriesInitialState,
  getStdDbModelReduxMapping(queriesActions),
);

export default queriesReducer;
